<!--
    描述：问题列表信息
    时间：2020-05-13
    Created by zwh
-->
<template>
    <div class="w-table-layout w-table-page">
        <transition name="fade" mode="out-in">
            <!-- 列表 -->
            <div class="list-wrap w-table-content" ref="tableContent" key="list">
                <el-table :data="tableObj.tableData"
                          row-key="id"
                          v-loading="tableObj.loading"
                          ref="tableObj"
                          default-expand-all
                          :height="tableObj.tableH"
                          border
                          highlight-current-row>
                    <el-table-column type="index" align="center" width="50"></el-table-column>
                    <el-table-column prop="createDate" label="异常时间" header-align="center" align="center" show-overflow-tooltip width="155"></el-table-column>
                    <el-table-column prop="ip" label="IP地址" header-align="center" show-overflow-tooltip width="120"></el-table-column>
                    <el-table-column prop="method" label="方法名称" header-align="center" show-overflow-tooltip min-width="100"></el-table-column>
                    <el-table-column prop="urlPath" label="请求URL" header-align="center" show-overflow-tooltip min-width="105"></el-table-column>
                    <el-table-column prop="messageInfo" label="错误信息" header-align="center" show-overflow-tooltip min-width="135"></el-table-column>
                    <el-table-column prop="userName" label="用户账号" header-align="center" show-overflow-tooltip min-width="50"></el-table-column>
                    <el-table-column prop="userSname" label="用户姓名" header-align="center" show-overflow-tooltip min-width="45"></el-table-column>
                    <el-table-column prop="isAround" label="问题触发位置" header-align="center" align="center" show-overflow-tooltip width="105">
                        <template slot-scope="scope">
                            <span v-if="scope.row.isAround === 1">前端</span>
                            <span v-if="scope.row.isAround !== 1">后台</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </transition>

        <!-- 底部分页 -->
        <div class="w-table-footer">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="tableObj.currentPage"
                           :page-sizes="tableObj.pageList"
                           :page-size="tableObj.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="tableObj.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { getPageList } from '@/api/modules/sys.js'
    export default {
        components: {},
        props : {},
        data() {
            return {
                searchObj : {
                    userName : '',
                    startDate : '',
                    endDate : '',
                    ip : '',
                    method : '',
                    urlPath : '',
                    isAround : '',
                },
                tableObj: {
                    loading: false,
                    tableH: 400,
                    tableData: [],
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                    pageList: [10, 20, 50, 100] // 显示条数数组
                }
            }
        },
        created() {
            this.getTablePageList()
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        // 进入缓存页面触发
        activated() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        methods: {
            searchPageList(obj){
                this.searchObj = obj
                this.tableObj.currentPage = 1
                this.getTablePageList()
            },
            getTablePageList(){
                let that = this

                let startDate = this.searchObj.startDate
                let endDate = this.searchObj.endDate
                if(startDate != null && startDate !='' && typeof(startDate) != 'undefined') startDate = startDate + " 00:00:00"
                if(endDate != null && endDate !='' && typeof(endDate) != 'undefined') endDate = endDate + " 23:59:59"

                let param = {}
                param.current = this.tableObj.currentPage
                param.size = this.tableObj.pageSize
                param.userName = this.searchObj.userName
                param.startDate = startDate
                param.endDate = endDate
                param.ip = this.searchObj.ip
                param.method = this.searchObj.method
                param.urlPath = this.searchObj.urlPath
                param.isAround = this.searchObj.isAround
                getPageList(param).then(res => {
                    if (res.operationCode == 1) {
                        that.tableObj.tableData = res.data.records
                        this.tableObj.total = parseInt(res.data.total)
                    }
                })
            },
            // 切换显示条数
            handleSizeChange(val) {
                this.tableObj.pageSize = val
                this.getTablePageList()
            },

            // 切换当前页码
            handleCurrentChange(cur) {
                this.tableObj.currentPage = cur
                this.getTablePageList()
            },
        },
        computed: {
            ...mapState('app', { clientSize: state => state.clientSize }),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                
            }
        },
    }
</script>

<style scoped>

</style>